import axios from "axios";
import dotenv from "react-dotenv";

/**
 * Centralized axios instance with automatic JWT authentication from localStorage.
 * Automatically adds Authorization header and logs errors.
 *
 * Usage:
 *   import axiosClient from "../utils/axiosClient";
 *   axiosClient.get("/institutions/v1/patients").then(res => console.log(res.data));
 */
const axiosClient = axios.create({
  baseURL: dotenv.API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosClient.interceptors.request.use((config) => {
  const userStr = localStorage.getItem("user");
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user?.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    } catch (error) {
      console.error("Error parsing user from localStorage:", error);
    }
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 401) console.error("Unauthorized - token may be invalid");
      else if (status === 403) console.error("Forbidden - insufficient permissions");
      else if (status === 404) console.error("Resource not found");
      else if (status === 422) console.error("Validation error:", error.response.data);
      else if (status >= 500) console.error("Server error:", status);
    } else if (error.request) {
      console.error("No response received from server");
    } else {
      console.error("Error setting up request:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
